(function(){
  window.addEventListener('load', function() {
    const gitAidSwitch = document.getElementById('edit-field-uk-tax-payer-value')
    const gitAidFields = document.getElementsByClassName('field-group-html-element')
    if (gitAidFields && gitAidFields[0] && gitAidSwitch) {
      const gitAidFieldGroup = gitAidFields[0]
      const gitAidFieldInput = gitAidFieldGroup.getElementsByTagName('input')
      const gitAiLabels = gitAidFieldGroup.getElementsByTagName('label')
      const gitAidFieldTextarea = gitAidFieldGroup.getElementsByTagName('textarea')
      //const countyField = gitAidFields.getElementById('edit-field-county-or-state-0-value')

      console.log(gitAidFieldTextarea)

      gitAidFieldGroup.classList.add('hidden')

      gitAidSwitch.addEventListener('click', function(){
      if (gitAidSwitch.checked) {
        gitAidFieldGroup.classList.remove('hidden')

        for (let target of gitAidFieldInput) {
          target.classList.add('required')
          target.required = true
        };
        for (let label of gitAiLabels) {
          label.classList.add('js-form-required')
        };
        gitAidFieldTextarea[0].setAttribute('required', true)
        countyField.setAttribute('required', true)

      } else {
        gitAidFieldGroup.classList.add('hidden')
        for (let target of gitAidFieldInput) {
          target.classList.remove('required')
          target.required = false
        };
        for (let label of gitAiLabels) {
          label.classList.remove('js-form-required')
        };
        gitAidFieldTextarea[0].removeAttribute('required')
        countyField.removeAttribute('required')

      }
      });
    }

  });
})();
